export const getters = {
  getIAAgents: $state => {
    return $state.records;
  },

  getIAAgentsIsEmpty: $state => {
    return Object.entries($state.records).length === 0;
  },
  
  getUIFlags: $state => $state.uiFlags,
  
  getIAAgentAssistants: $state => {
    const agent = $state.records;
    return agent ? agent.assistant || {} : {};
  },
  
  getIAAgentKnowledgeSources: $state => {
    const agent = $state.records;
    return agent ? agent.knowledge_sources || [] : [];
  },
  
  isIAAgentLoaded: $state => id => {
    return !!$state.records;
  },
  
  isIAAgentsEmpty: $state => {
    return $state.records == {};
  },
}; 